import dotProp from 'dot-prop-immutable'
import { connect } from 'react-redux'
import { toggleNavigationWalls } from '../../actions/sidebar'
import getWallpapers from '../../repositories/getWallpapers'
import NavigationItem from './../../components/NavigationItem'

const mapStateToProps = state => ({
  isToggled: dotProp.get(state, `sidebar.walls.isToggled`, false),
})

const mapDispatchToProps = dispatch => ({
  toggle: () => dispatch(toggleNavigationWalls(getWallpapers(window.fetch))),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationItem)



// WEBPACK FOOTER //
// ./src/containers/NavigationItem/WallpapersItem.js